import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Reminder } from "../../redux/alerts";
import { feedbackDTO } from "../../redux/residentActivityPlan";
import { residentsCreator } from "../../redux/residents/selectors";
import { IAppState } from "../../redux/types";
import { Dispatcher } from "../../service/RootDispather";
import { AvatarResidentUser } from "../common/AvatarUser";
import { OverflowTip, RoomBedDisplayByMin } from "../common/Common";
import { ModalTypes } from "../status/Callbacks";
import "./styles.scss";

const ActivityFeedback = ({
  callback,
  residentId,
  reminder,
}: {
  callback: (...params: any) => void;
  residentId: string;
  reminder: Reminder;
}): JSX.Element => {
  const ResidentSelection = useMemo(() => residentsCreator(), []);
  const resident = useSelector((state: IAppState) =>
    ResidentSelection(state, residentId)
  );
  const texts = useSelector(
    (state: IAppState) =>
      state.residentActivityPlan.feedbackOptions[reminder.activityType]
        .radioButtons
  );
  const [listItemSelected, setlistItemSelected] = useState(
    Object.keys(texts)[0]
  );
  const [checkBoxSelected, setcheckBoxSelected] = useState([]);
  const [subRadioSelected, setsubRadioSelected] = useState(undefined);
  const tStatus = useTranslation("status").t;
  const tCommon = useTranslation("common").t;
  const rootDispatcher = Dispatcher();

  const onConfirmEdit = useCallback(() => {
    if (!listItemSelected) return;
    let feedback: feedbackDTO = {
      radioButtons: { [listItemSelected.toString()]: true },
    };

    if (checkBoxSelected.length > 0 && subRadioSelected === undefined) {
      const checkList = {};
      checkBoxSelected.map((el) => {
        checkList[el.toString()] = true;
        return null;
      });
      feedback = {
        radioButtons: {
          [listItemSelected.toString()]: { checkBoxes: checkList },
        },
      };
    } else if (checkBoxSelected.length > 0) {
      const checkList = {};
      checkBoxSelected.map((el, index) => {
        if (typeof texts[listItemSelected]["checkBoxes"][el] === "object")
          checkList[el.toString()] = {
            radioButtons: { [subRadioSelected.toString()]: true },
          };
        else checkList[el.toString()] = true;
        return null;
      });
      feedback = {
        radioButtons: {
          [listItemSelected.toString()]: {
            checkBoxes: checkList,
          },
        },
      };
    }
    rootDispatcher.sendResidentActivity({
      residentId: residentId,
      activityType: reminder.activityType,
      feedback,
    });

    callback(ModalTypes.BACK);
  }, [
    callback,
    residentId,
    listItemSelected,
    rootDispatcher,
    reminder,
    checkBoxSelected,
    subRadioSelected,
    texts,
  ]);

  const onCloseHandler = useCallback(() => {
    callback(ModalTypes.BACK);
  }, [callback]);
  const [isOutputSelected, setIsOutputSelected] = useState(false);

  const onSelectHandler = useCallback(
    (value: string) => {
      setlistItemSelected(value);
      if (value !== "No Outputs" && typeof texts[value] === "object") {
        setcheckBoxSelected([Object.keys(texts[value]["checkBoxes"])[0]]);
      }
      if (value === "Outputs") {
        if (!isOutputSelected) {
          setcheckBoxSelected([Object.keys(texts[value]["checkBoxes"])[0]]);
          console.log([Object.keys(texts[value]["checkBoxes"])[0]]);
          setIsOutputSelected(true);
        }
      } else {
        setcheckBoxSelected([]);
        setsubRadioSelected(undefined);
        setIsOutputSelected(false);
      }
    },
    [isOutputSelected, texts]
  );

  const onClickCheckBoxes = useCallback(
    (checkValue: string, radioValue: string) => {
      setlistItemSelected(radioValue);
      if (checkBoxSelected.indexOf(checkValue) === -1) {
        setcheckBoxSelected(checkBoxSelected.concat(checkValue));
        if (typeof texts[radioValue]["checkBoxes"][checkValue] === "object")
          setsubRadioSelected(
            Object.keys(
              texts[radioValue]["checkBoxes"][checkValue]["radioButtons"]
            )[0]
          );
      } else {
        setcheckBoxSelected(checkBoxSelected.filter((el) => el !== checkValue));
        if (typeof texts[radioValue]["checkBoxes"][checkValue] === "object")
          setsubRadioSelected(undefined);
      }
    },
    [checkBoxSelected, texts]
  );

  const onSelectSubRadioHandler = useCallback(
    (topRadio, checkBox, subRadio) => {
      setlistItemSelected(topRadio);
      setcheckBoxSelected(checkBoxSelected.concat(checkBox));
      setsubRadioSelected(subRadio);
    },
    [checkBoxSelected]
  );

  useEffect(() => {
    if (
      (checkBoxSelected.length === 0 &&
        !subRadioSelected &&
        listItemSelected === "Outputs") ||
      listItemSelected === "No Outputs"
    ) {
      setlistItemSelected(Object.keys(texts)[0]);
    }
  }, [checkBoxSelected, subRadioSelected]);

  return (
    <div className={`modal-sm feedback-modal mobile`}>
      <div className="flex-column flex-column-24">
        <div className="flex-center flex-column">
          <div className="flex-gap  flex-gap-8">
            <AvatarResidentUser profile={resident} size={"24"} />
            <RoomBedDisplayByMin
              devicesMinimized={resident?.devicesMinimized}
            />
          </div>
          <OverflowTip
            text={`${resident.firstName} ${resident.lastName}`}
            className="center"
          />
          <span>{tStatus("feedback")}</span>
        </div>

        <div
          className="flex-gap flex-gap-8"
          style={{
            justifyContent: "center",
            marginBottom: "10px",
            marginTop: "8px",
          }}
        >
          <div className="alert-32">
            <i
              className={`icon-alert info icon-action-${reminder.activityType}`}
            />
          </div>
          <p style={{ marginLeft: "5px" }}>
            {tCommon("activities." + reminder.activityType)}
          </p>
        </div>

        <div className="list-wrap">
          <ul className={`feedback-list ${reminder.activityType}`}>
            {Object.keys(texts).map((key: string) => {
              const textFixed: string =
                typeof key === "string" ? key : Object.keys(key)[0];

              return (
                <li
                  key={textFixed}
                  className={`form-control ${
                    listItemSelected === key ? "selected" : ""
                  } ${reminder.activityType} ${
                    key === "Outputs" ? "form-outputs" : ""
                  }`}
                  onClick={() => onSelectHandler(textFixed)}
                >
                  <div
                    className={`radio flex-center-radio ${reminder.activityType}`}
                  >
                    <input
                      type={"radio"}
                      id={textFixed}
                      checked={listItemSelected === key || false}
                      name="feedback"
                    />

                    <label className="md-l-10" htmlFor={textFixed}>
                      <FeedBackToIcon feedback={key} isBig={true} />
                      <span className="text-size-14">{tStatus(textFixed)}</span>
                    </label>
                  </div>
                  {typeof texts[key] === "object" && (
                    <React.Fragment key={Object.keys(texts[key]).length}>
                      {texts[key]["checkBoxes"] !== undefined ? (
                        <div className="sub-list-one">
                          {Object.keys(texts[key]["checkBoxes"]).map(
                            (el, index) => {
                              console.log(subRadioSelected);
                              const me = (
                                <React.Fragment key={key + el + index}>
                                  <div
                                    className={`checkbox checkbox-sm check-text flex-center-radio `}
                                    key={key + el}
                                    onChange={() => onClickCheckBoxes(el, key)}
                                  >
                                    <input
                                      type="checkbox"
                                      key={el}
                                      className="checkbox-profile"
                                      id={el}
                                      checked={
                                        // el=== "Feces" ? subRadioSelected[0] === "Urine" || subRadioSelected[0] === "" &&
                                        el === "Feces"
                                          ? subRadioSelected ===
                                              "Normal stool" ||
                                            subRadioSelected === "Diarrhea"
                                          : checkBoxSelected.indexOf(el) !==
                                              -1 || false
                                      }
                                    />
                                    <label className="md-l-10" htmlFor={el}>
                                      <i
                                        className={`icon-feedback-${el
                                          .toLowerCase()
                                          .replace(new RegExp(" ", "g"), "-")}`}
                                        style={{
                                          paddingRight: "4px",
                                          verticalAlign: "middle",
                                        }}
                                      />
                                      <span>{tStatus(el)}</span>
                                    </label>
                                  </div>
                                  {typeof texts[key]["checkBoxes"][el] ===
                                    "object" && (
                                    <div className="sub-list-two">
                                      {Object.keys(
                                        texts[key]["checkBoxes"][el][
                                          "radioButtons"
                                        ]
                                      ).map((radioLast) => {
                                        return (
                                          <div
                                            className={
                                              "radio flex-center-radio"
                                            }
                                            key={key + el + radioLast}
                                            onClick={() =>
                                              onSelectSubRadioHandler(
                                                key,
                                                el,
                                                radioLast
                                              )
                                            }
                                          >
                                            <input
                                              type={"radio"}
                                              id={radioLast}
                                              checked={
                                                subRadioSelected === radioLast
                                              }
                                              name={el}
                                            />
                                            <label
                                              className="md-l-10"
                                              htmlFor={radioLast}
                                            >
                                              <i
                                                className={`icon-feedback-${radioLast
                                                  .toLowerCase()
                                                  .replace(
                                                    new RegExp(" ", "g"),
                                                    "-"
                                                  )}`}
                                                style={{
                                                  paddingRight: "4px",
                                                  verticalAlign: "middle",
                                                }}
                                              />
                                              <>{tStatus(radioLast)}</>
                                            </label>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                </React.Fragment>
                              );

                              return typeof texts[key]["checkBoxes"][el] ===
                                "object" ? (
                                <div
                                  className={`givno  ${
                                    checkBoxSelected.indexOf(el) !== -1
                                      ? "selected"
                                      : ""
                                  } `}
                                >
                                  {me}
                                </div>
                              ) : (
                                me
                              );
                            }
                          )}
                        </div>
                      ) : null}
                    </React.Fragment>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div
          className="flex-column flex-column-8"
          style={{ marginTop: "10px" }}
        >
          <button
            className="btn primary with-icon full-width save-view"
            onClick={onConfirmEdit}
          >
            <i className="icon-feedback-done" />
            {tCommon("buttons.Save")}
          </button>
          <button
            style={{ marginTop: "10px" }}
            className="btn  with-icon full-width save-view"
            onClick={onCloseHandler}
          >
            <i className="icon-close" />
            {tStatus("noFeedback")}
          </button>
        </div>
      </div>
    </div>
  );
};

export const FeedBackToIcon = ({
  feedback,
  isBig,
}: {
  feedback: string;
  isBig: boolean;
}): JSX.Element => {
  if (!feedback || feedback === "") return null;
  return feedback.indexOf("Didn") !== -1 ||
    feedback.indexOf("Refused") !== -1 ||
    feedback.indexOf("Done") !== -1 ? (
    <i
      className={`icon-feedback-${
        feedback.indexOf("Done") !== -1 ? "done" : "refused"
      }`}
      style={{ paddingRight: "4px", verticalAlign: "middle" }}
    />
  ) : (
    // </div>
    <>
      {feedback.indexOf("Physically") !== -1 ? (
        <i
          className={`icon-minus`}
          style={{ paddingRight: "4px", verticalAlign: "middle" }}
        />
      ) : (
        <i
          className={`icon-feedback-${feedback
            .toLowerCase()
            .replace(new RegExp(" ", "g"), "-")
            .replace("(", "")
            .replace(")", "")}`}
          style={{ paddingRight: "4px", verticalAlign: "middle" }}
        />
      )}
    </>
  );
};

export default React.memo(ActivityFeedback);
